import { useQuery } from "@tanstack/react-query";
import { fetchReviews } from "./api/reviews";

export const useGetReviews = (product, page) => {
  return useQuery({
    queryKey: ["reviews", page, product?.id],
    queryFn: () => fetchReviews(product?.id, page),
    enabled: !!product,
    keepPreviousData: true,
  });
};
